<template>
    <div class="tp" ref="textTemplate" @click="onQueryWord">
        <van-popup
            position="bottom"
            get-container="body"
            :safe-area-inset-bottom="true"
            :duration="0.18"
            :closeable="true"
            v-model="isShowWordDetails"
            @close="onCloseWordDetails"
            class="word-popup"
        >
            <div class="word-title">
                <span>{{ word }}</span>
                <span @click="onPlayAudio" v-if="audioUrl">
                    <audio ref="audio" :src="audioUrl" />
                    <van-icon name="volume-o" />
                </span>
            </div>
            <div class="word-details">
                <div class="phonetic-transcription" v-if="phoneticAM || phoneticEN">
                    <span v-if="phoneticAM">
                        <span class="label">美</span><span>[{{ phoneticAM }}]</span>
                    </span>
                    <span v-if="phoneticEN">
                        <span class="label">英</span><span>[{{ phoneticEN }}]</span>
                    </span>
                </div>
                <div class="part-item" v-for="(item, index) in senses" :key="index">
                    {{ item.part }} {{ item.means.join('; ') }}
                </div>
                <div class="edict-list" v-if="examples.length !== 0">
                    <div class="edict-title">英英释义:</div>
                    <div class="edict-item" v-for="(item, index) in examples" :key="index">
                        <div class="edict-pos">{{ item.pos }}</div>
                        <div class="group" v-for="(group, groupIndex) in item.tr_group" :key="groupIndex">
                            <div class="group-title">
                                <span class="group-index">{{ groupIndex + 1 }}. </span>
                                <span>{{ group.tr[0] }}</span>
                            </div>
                            <div class="example" v-for="(example, exampleIndex) in group.example" :key="exampleIndex">
                                {{ example }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </van-popup>
    </div>
</template>
<script>
import { getWordHandout } from '@/api/paperApi.js'

export default {
    props: {
        text: { type: String, default: '' },
        explain: { type: Boolean, default: true },
    },
    data() {
        return {
            isShowWordDetails: false,

            word: '',
            phoneticAM: '',
            phoneticEN: '',
            audioUrl: '',
            senses: [],
            examples: [],
        }
    },
    mounted() {
        // <right></right>
        // <center></center>
        // <underline></underline>
        // <bold></bold>
        // <italic></italic>
        // <indent></indent>
        // <u-blank>
        const elMap = [
            { el: '<right>', output: '<div class="right">' },
            { el: '</right>', output: '</div>' },
            { el: '<center>', output: '<div class="center">' },
            { el: '</center>', output: '</div>' },
            { el: '<underline>', output: '<div class="underline">' },
            { el: '</underline>', output: '</div>' },
            { el: '<bold>', output: '<div class="bold">' },
            { el: '</bold>', output: '</div>' },
            { el: '<italic>', output: '<div class="italic">' },
            { el: '</italic>', output: '</div>' },
            { el: '<indent>', output: '<div class="indent">' },
            { el: '</indent>', output: '</div>' },
            { el: '<u-blank>', output: '<div class="u-blank"></div>' },
        ]
        let content = this.text
        elMap.forEach((item) => {
            content = content ? content.replace(new RegExp(item.el, 'g'), item.output) : ''
        })
        // 使用 v-html 会将 popup 清空，使用innerHTML 代替
        this.$refs.textTemplate.innerHTML = content
    },
    methods: {
        onQueryWord(event) {
            const _isImg = this.isImgElement(event.target)
            if (_isImg) {
                if (event.target.src) {
                    this.previewImage(event.target)
                }
                return
            }

            if (!this.explain) return
            // 提取点击单词
            this.word = this.getWord()
            if (!this.word) return
            this.isShowWordDetails = true
            this.$nextTick(() => {
                getWordHandout({ word: this.word }).then((res) => {
                    const wordData = res.data.transResults[0]
                    this.audioUrl = wordData.src_tts
                    try {
                        const { simple_means, edict } = wordData.dict.word_result
                        this.phoneticAM = simple_means.symbols[0].ph_am || ''
                        this.phoneticEN = simple_means.symbols[0].ph_en || ''
                        if (edict && edict.item) {
                            this.examples = edict.item || []
                        }

                        this.senses = simple_means.symbols[0].parts || []
                    } catch (_) {
                        this.senses = [{ part: '', means: [wordData.dst] }]
                    }
                })
            })
        },
        onPlayAudio() {
            this.$refs.audio.play()
        },
        onCloseWordDetails() {
            this.word = ''
            this.phoneticAM = ''
            this.phoneticEN = ''
            this.audioUrl = ''
            this.senses = []
            this.examples = []
        },
        getWord() {
            const selection = window.getSelection()
            const range = selection.getRangeAt(0)
            const text = selection.anchorNode

            // range.setStart(text, range.startOffset)
            // range.setEnd(text, range.endOffset === text.length ? range.endOffset : range.endOffset + 1)
            // // 选中位置无字母
            // if (!rule.test(range.toString())) {
            //     range.setStart(text, 0)
            //     range.setEnd(text, 0)
            //     this.$toast('dddd')
            //     return ''
            // }

            const rule = /-|[a-z]|[A-Z]/

            while (rule.test(range.toString()[0]) && range.startOffset > 0) {
                range.setStart(text, range.startOffset - 1)
            }
            if (!rule.test(range.toString()[0])) {
                range.setStart(text, range.startOffset + 1)
            }

            while (rule.test(range.toString()[range.toString().length - 1]) && range.endOffset <= text.length - 1) {
                range.setEnd(text, range.endOffset + 1)
            }
            if (!rule.test(range.toString()[range.toString().length - 1])) {
                range.setEnd(text, range.endOffset - 1)
            }

            // 仅选中一个字母/-时
            // if (range.toString().trim().length === 1) {
            //     range.setStart(text, 0)
            //     range.setEnd(text, 0)
            //     return ''
            // }
            return range.toString().trim()
        },

        isImgElement(element) {
            return element && element.tagName === 'IMG'
        },
        previewImage(element) {
            if (element.style.width && !element.default_width) {
                element.default_width = element.style.width
            }
            if (element.style.width === '100%') {
                element.style.width = element.default_width || ''
            } else if (element.style.width !== '100%') {
                element.style.width = '100%'
                element.style.height = 'auto'
            }
        },
    },
}
</script>
<style lang="scss" scoped>
.tp {
    white-space: pre-wrap;
    ::v-deep img {
        width: auto;
        display: inline-block;
    }
}
::v-deep .right {
    text-align: right;
}
::v-deep .center {
    text-align: center;
}
::v-deep .underline {
    display: inline;
    text-decoration: underline;
}
::v-deep .bold {
    display: inline;
    font-weight: 700;
}
::v-deep .italic {
    display: inline;
    font-style: italic;
}
::v-deep .u-blank {
    display: inline-block;
    text-decoration: underline;
    &::after {
        content: '     ';
        display: inline-block;
        text-decoration: underline;
    }
}
::v-deep .indent {
    text-indent: 2em;
}
</style>
<style lang="scss" scoped>
.word-popup {
    max-height: 400px;
    height: 80vh;
}
.word-title {
    line-height: 54px;
    padding: 0 24px;
    font-weight: 700;
    display: flex;
    align-items: center;
    font-size: 24px;
    border-bottom: 1px solid #efefef;
    position: relative;
    audio {
        opacity: 0;
        width: 0;
        height: 0;
        position: absolute;
    }
    .van-icon {
        margin-left: 16px;
        font-size: 18px;
        color: red;
    }
}
.word-details {
    height: calc(100% - 55px);
    padding: 20px 28px;
    overflow-y: auto;
    box-sizing: border-box;
    .phonetic-transcription {
        line-height: 1.4em;
        margin-bottom: 16px;
        font-size: 15px;
        > span {
            margin-right: 12px;
            color: #999;
        }
        .label {
            margin-right: 6px;
            font-size: 14px;
            color: #333;
        }
    }
    .part-item {
        font-size: 14px;
        color: #333;
        line-height: 1.4em;
        letter-spacing: 1.5px;
        margin-bottom: 4px;
    }
    .edict-list {
        margin-top: 24px;
    }
    .edict-title {
        font-size: 15px;
        color: #333;
        font-weight: 700;
    }
    .edict-item {
        font-size: 15px;
        margin-top: 8px;
        .edict-pos {
            line-height: 24px;
            color: #333;
            font-weight: 700;
        }
        .group {
            margin-bottom: 8px;
        }
        .group-title {
            line-height: 1.4em;
        }
        .example {
            font-size: 14px;
            color: #999;
            margin-bottom: 6px;
        }
    }
}
.word-handout {
    line-height: 1.8em;
    font-size: 14px;
    white-space: pre-line;
}
</style>
